// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"7b18dc34","399":"3cdc9a82","453":"9dce8499","798":"af85254a","856":"fd5d4c39"}[chunkId] + ".chunk.js";
};